// @flow
import * as React from "react"
import { css } from "react-emotion/macro"
import { hot } from "react-hot-loader"
import { Layout } from "../../components/Layout"
import { ImageFit } from "../../components/ImageFit"
import { Container } from "../../components/StyledComponents"
import { Link } from "react-static"
import type { tRouteProps, tDefaultTemplate } from "../../types"
import type { tPage } from "../Page"
import { PageMarquee } from "../../components/PageMarquee/index"
import { peopleSection } from "./style"
import sortBy from "lodash.sortby"
import { PageMeta } from "../../components/PageMeta"
import Obfuscate from "react-obfuscate"

type tOurPeople = tPage

const OurPeople = (props: tPage) => {
  return (
    <React.Fragment>
      {props.default_template_content && (
        <PageMarquee image={props.default_template_content.marquee_image} />
      )}
      <Container
        className={css`
          position: relative;
          margin-top: 60px;

          .prayer-container {
            position: relative;

            #prayer {
              position: absolute;
              top: -200px;
              left: 0;
              right: 0;
            }
          }
        `}
      >
        <h2 className="text-center">Our People</h2>
        <PeopleSection>
          <div>
            <h3 className="h4 text-center">Ministers and Staff</h3>
            <PersonList {...props} section="staff" />
          </div>
          <div>
            <h3 className="h4 text-center">Trustees and Corporate Officers</h3>
            <PersonList {...props} section="officers" />
          </div>
          <div>
            <h3 className="h4 text-center">Practitioner Council</h3>
            <PersonList {...props} section="practitioner_council" />
          </div>
          <div className="prayer-container">
            <div id="prayer" />
            <h3 className="h4 text-center">Prayer Practitioners</h3>
            <PersonList {...props} section="prayer_practitioner" />
          </div>
        </PeopleSection>
      </Container>
    </React.Fragment>
  )
}

export type tPeopleSection = {
  children: React.Node
}

export type tPeopleSectionState = {}

export class PeopleSection extends React.Component<
  tPeopleSection,
  tPeopleSectionState
> {
  render() {
    return <section className={peopleSection}>{this.props.children}</section>
  }
}

let honorifics = ["DD", "MCS", "RScP"]

export function PersonList(props: tPage & tRouteProps & tDefaultTemplate) {
  return (
    <div className="people-list">
      <PageMeta
        title={props.title}
        description="Ministers, Staff, Trustees, Corporate Officers, and Prayer Practitioners of CSL"
        image={props.brand.logo}
      />
      {sortBy(props.people, [
        function(person) {
          const nameParts = person.title.rendered
            .replace(",", "")
            .replace("*", "")
            .trim()
            .split(" ")

          let lastWord = nameParts[nameParts.length - 1]
          let wordBeforeLast = nameParts[nameParts.length - 2]

          if (lastWord === "clients.") {
            /* 
            This is a brittle hack. 
            The entry ending with the phrase "clients" is currently an informational entry meant to show up in the second position in the list. 
            So I'm artifically giving it a last name similar to the last name of the entry that is currently in the first position. */
            return "Antipas-hack"
          }
          let lastName = honorifics.includes(lastWord) ? wordBeforeLast : lastWord 
          return lastName
        }
      ])
        .filter((person) =>
          person.acf.person_content.type.includes(props.section)
        )
        .map((person) => {
          const {
            id,
            title: { rendered: name },
            acf: {
              person_content: { email, headshot, phone, title }
            }
          } = person
          return (
            <div className="person" key={id}>
              {headshot &&
                (person.acf.person_content.type.includes("staff") ? (
                  <Link to={`/people/${person.slug}`}>
                    <ImageFit src={headshot.url} alt={name} />
                  </Link>
                ) : (
                  <ImageFit src={headshot.url} alt={name} />
                ))}
              <div className="info">
                {person.acf.person_content.type.includes("staff") ? (
                  <Link to={`/people/${person.slug}`}>
                    <h4 dangerouslySetInnerHTML={{__html: name}} />
                  </Link>
                ) : (
                  <h4 dangerouslySetInnerHTML={{__html: name}} />
                )}
                <div className="title">{title}</div>
                <div className="email">
                  <Obfuscate email={email} />
                </div>
                {phone && (
                  <div className="phone">
                    <a href={`tel:${phone.url}`}>phone {phone.label}</a>
                  </div>
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}

function RenderOurPeople(props: tOurPeople) {
  return (
    <Layout>{(routeProps) => <OurPeople {...props} {...routeProps} />}</Layout>
  )
}

export default hot(module)(RenderOurPeople)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/OurPeople/index.js